module.exports = __webpack_public_path__ + "img/tuin_vijver.60659941.png";